// This optional code is used to register a service worker.
// register() is not called by default.

import AsyncStorage from "@react-native-community/async-storage";
import { Auth } from "aws-amplify";
import { APIs } from "./util/api/APIs";
import SafeairManager from "./util/api/SafeairManager";
import { Mixpanel } from "./util/Helper";

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

// window.addEventListener("load", () => {
//   navigator.serviceWorker.getRegistrations().then(async function(registrations) {
//     for(let registration of registrations) {
//       console.log("registration before register",registration);
//         await registration.unregister();
//     } 
// });
// })

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Check webapp visibility (foreground or background) 
// window.addEventListener("load", () => {
//   document.addEventListener("visibilitychange", () => {
//     console.log("visibilityState",document.visibilityState);
//     if (document.hidden) {
//       Mixpanel.track("web_background")
//     } else {
//       Mixpanel.track("web_foreground");
//     }
//   });
// });

export function register(config) {
  if (
    process.env.NODE_ENV === "production" ||
    (process.env.NODE_ENV === "development" && "serviceWorker" in navigator)
  ) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }
    console.log("public url: ", process.env.PUBLIC_URL);
    const unregisterAndRegister = async (swUrl2) => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        console.table("registrations",registrations);
        for (const registration of registrations) {
          await registration.unregister();
          console.log("registration - unregister",registration);
        }
        
        const newRegistration = await navigator.serviceWorker.register(swUrl2);
        console.log("newRegistration",newRegistration);
        newRegistration.onupdatefound = () => {
          const installingWorker = newRegistration.installing;
          console.log("installingWorker", installingWorker);
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  console.log("New content is available; please refresh.");
                } else {
                  console.log("Content is cached for offline use.");
                }
                if (config && config.onUpdate) {
                  config.onUpdate(newRegistration);
                }
              }
            };
          }
        };

        // Additional logic for handling new registration
        // ...

        return newRegistration;
      } catch (error) {
        console.error("Error updating service worker:", error);
        throw error;
      }

    }
    window.addEventListener("load", async () => {
      // set user for mix panel
      console.log("userSetFor",localStorage.getItem("userSetForMixpanel"))
      if (localStorage.getItem("userSetForMixpanel") !== "1") {
        // let data = await Auth.currentUserInfo();

        let data;
        let uInfo = localStorage.getItem("userinfo");
        if (uInfo) {
          data = JSON.parse(uInfo);
          }
        let siteEnviornment;
        if (APIs.BASE_URL.indexOf("sbx") >= 0) {
          siteEnviornment = "SBX";
        } else if (APIs.BASE_URL.indexOf("poc") >= 0) {
          siteEnviornment = "POC";
        } else {
          siteEnviornment = "PROD";
        }
        //console.log("userData",data);
        //console.log("userData email",data.email);
        //console.log("userData email type",typeof(data.email));
        if(data !== undefined){
          Mixpanel.identify(data.sub);
          Mixpanel.people.set({$name: data.username,$email: data.email,$env: siteEnviornment})
          Mixpanel.track("web_user_login",{name: data.username});
          localStorage.setItem("userSetForMixpanel", 1);
        }
        //console.log("userCognitoId",data.sub);
      }
       const swUrl = `${process.env.PUBLIC_URL}/service-worker.js?v=${new Date().getTime()}`;
      console.log("sw url: ", swUrl);
      // unregisterAndRegister(swUrl);
      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service " +
              "worker. To learn more, visit https://cra.link/PWA"
          );
        });
        registerValidSW(swUrl, config);
        // unregisterAndRegister(swUrl);
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}


function registerValidSW(swUrl, config) {
  localStorage.removeItem("registerEndPointError");
//   navigator.serviceWorker.getRegistrations().then(async function(registrations) {
//     for(let registration of registrations) {
//       console.log("registration before register",registration);
//         await registration.unregister();
//     } 
// });
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      navigator.serviceWorker.ready.then((sv) => {
        console.log("got sw registration");
        let output = sv.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey:
            "BCTU1b90aDb-v2i_3Ry6PEjyr6-N5zeH9WA78mDLTMXhcMhP5JNYNWBWw8nSvzflRCXEvsm1EmgZCZ5TK2YMYcs",
        });
        output
          .then(async (result) => {
            // {"endpoint":"","keys":{"auth":"","p256dh":""}}
            console.log("endpointDetails",result);
            var endpointDetails = JSON.parse(JSON.stringify(result));
            localStorage.setItem("endpointUrl", endpointDetails.endpoint);
            localStorage.setItem("auth", endpointDetails.keys.auth);
            localStorage.setItem("p256dh", endpointDetails.keys.p256dh);
            try {
              // console.log("username in service worker", (await Auth.currentUserInfo()).username);
              // await Auth.currentAuthenticatedUser();

              let username;
              let uInfo = localStorage.getItem("userinfo");
              if (uInfo) {
              username = JSON.parse(uInfo)?.username;
              }
              // let username = (await Auth.currentUserInfo()).username;
              SafeairManager.invoke({
                api: APIs.Endpoint.RegisterEndpoint,
                parameters: null,
                body: {
                  endpointUrl: endpointDetails.endpoint,
                  auth: endpointDetails.keys.auth,
                  p256dh: endpointDetails.keys.p256dh,
                  username: username
                },
              }).then((r) => {
                console.log("registered endpoint in system: ", JSON.stringify(r));
              });
            } catch (e) {
              console.log("register error", e);
            }

            console.log("push-notification-web-push", JSON.stringify(result));
          })
          .catch((e) => {
            console.error("error occ web-push: ", e);
            localStorage.setItem("registerEndPointError", e);
          });
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        // caches.keys().then((cacheNames) => {
        //   console.table('cacheNames',cacheNames);
        //   return Promise.all(
        //     cacheNames.map((cacheName) => {
        //       return caches.delete(cacheName);
        //       // if (cacheName.startsWith("your-cache-prefix")) {
        //       //   return caches.delete(cacheName);
        //       // }
        //       // return null;
        //     })
        //   );
        // });
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            console.log(JSON.stringify((navigator.serviceWorker.controller)));
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                "New content is available and will be used when all " +
                  "tabs for this page are closed. See https://cra.link/PWA."
              );
              installingWorker.postMessage({ type: 'SKIP_WAITING' });   

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log("Content is cached for offline use.");

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

